import { css } from 'styled-components';

export default css`
  /* Customs styles go here */
`;
